// extracted by mini-css-extract-plugin
export var subtitle = "_as-2";
export var title = "_as-0";
export var titleNoWrap = "_as-1";